import React, { useEffect, useState } from 'react'

import EditBlockButton from './Controls/EditBlockButton'
import StatisticPreview from './Components/StatisticPreview'
import { TreasureHuntModal } from './Modals/TreasureHuntModal'
import { TreasureHuntPreview } from './Modals/TreasureHuntModal/components/TreasureHuntPreview'

/**
 * TreasureHunt
 */

const TreasureHunt = ({ struct, enableTimer, onUpdate, id, colorTheme, pagesData }) => {
    const [isModalActive, setModalActive] = useState(false)

    useEffect(() => {
        if (struct.tiles.tileList.length > 0) {
            struct.tiles.tileList = struct.tiles.tileList.map(tile => {
                if (!tile.overlaySrc) {
                    tile.color = colorTheme
                }
                return tile
            })
        }
    }, [colorTheme])

    const openModal = evt => {
        evt.preventDefault()
        setModalActive(true)
    }

    const closeModal = () => {
        setModalActive(false)
    }

    return (
        <div className="treasure-hunt-block">
            <EditBlockButton onClick={openModal} />
            {enableTimer && <StatisticPreview actionsTitle="Number of moves" />}
            <TreasureHuntPreview
                colorTheme={colorTheme}
                tiles={struct.tiles ? struct.tiles.tileList : []}
                layout={struct.playground ? struct.playground.layout : { value: 4, rows: 2, cols: 2, label: '2x2' }}
                isShowCover={struct.playground ? struct.playground.isShowCover : false}
                coverHeader={struct.playground ? struct.playground.coverHeader : null}
                coverButtonText={struct.playground ? struct.playground.coverButtonText : null}
                isModal={false}
            />
            {isModalActive && (
                <TreasureHuntModal
                    data={{
                        structure: struct,
                        pages: pagesData,
                        colorTheme,
                        id,
                    }}
                    methods={{
                        closeModal: closeModal,
                        save: onUpdate,
                    }}
                />
            )}
        </div>
    )
}

export default TreasureHunt
